import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import AppLogo from '../../components/AppLogo'
import { shellConsumerRegisterUrl } from '../../utils/shellConsumerLoginUrl'

/**
 * El alta comercial Food (Wompi + pendiente de activación) vive en el ecosistema.
 * Nest /register no debe crear USER activo ni enviar bienvenida como si ya pagó.
 */
export default function RegisterPage() {
  const url = shellConsumerRegisterUrl()

  useEffect(() => {
    window.location.replace(url)
  }, [url])

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-6">
      <div className="max-w-md text-center">
        <AppLogo size={56} className="mx-auto mb-4" />
        <h1 className="text-xl font-bold text-gray-900 mb-2">Registro Food Plan</h1>
        <p className="text-gray-600 text-sm mb-4">
          El alta se hace en Ecosistema Fit: primero el pago (Wompi) y queda pendiente
          hasta que el administrador de Food Plan active tu cuenta.
        </p>
        <a href={url} className="text-primary-600 font-medium underline">
          Continuar al registro
        </a>
        <p className="text-sm text-gray-500 mt-4">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" className="text-primary-600 font-medium underline">Inicia sesión</Link>
        </p>
      </div>
    </div>
  )
}
